<div class="account-page">

  <!-- ── Header ── -->
  <div class="page-header">
    <div class="page-header-left">
      <button mat-icon-button (click)="goBack()" matTooltip="Back">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div>
        <h1 class="page-title">My Account</h1>
        <p class="page-subtitle">@{{ username }}</p>
      </div>
    </div>
  </div>

  <!-- ── Success banner ── -->
  <div class="save-success" *ngIf="saveSuccess">
    <mat-icon>check_circle</mat-icon>
    Account updated successfully.
  </div>

  <!-- ── Error banner ── -->
  <div class="save-error" *ngIf="saveError">
    <mat-icon>error_outline</mat-icon>
    {{ saveError }}
  </div>

  <form [formGroup]="accountForm" (ngSubmit)="onSubmit()" *ngIf="accountForm">

    <!-- ── Personal info ── -->
    <div class="form-card">
      <h2 class="form-section-title">Personal Information</h2>

      <div class="form-row two-col">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>First Name</mat-label>
          <input matInput formControlName="firstName" />
          <mat-error>First name is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="lastName" />
          <mat-error>Last name is required</mat-error>
        </mat-form-field>
      </div>

      <div class="form-row two-col">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" />
          <mat-error *ngIf="accountForm.get('email')?.hasError('required')">Email is required</mat-error>
          <mat-error *ngIf="accountForm.get('email')?.hasError('email')">Enter a valid email</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Phone</mat-label>
          <input matInput type="tel" formControlName="phone" placeholder="(555) 555-5555" />
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Address</mat-label>
          <input matInput formControlName="address" placeholder="123 Main St, City, State" />
        </mat-form-field>
      </div>

      <div class="form-row" *ngIf="isProvider">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Service Area</mat-label>
          <input matInput formControlName="serviceArea" placeholder="e.g. Boston, MA; Cambridge, MA" />
          <mat-hint>Comma-separated cities or regions where you offer services</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <!-- ── Change password ── -->
    <div class="form-card">
      <h2 class="form-section-title">Change Password</h2>
      <p class="form-section-hint">Leave blank to keep your current password.</p>

      <div class="form-row two-col">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>New Password</mat-label>
          <input matInput type="password" formControlName="newPassword" autocomplete="new-password" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Confirm New Password</mat-label>
          <input matInput type="password" formControlName="confirmPassword" autocomplete="new-password" />
          <mat-error *ngIf="passwordMismatch">Passwords do not match</mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- ── Actions ── -->
    <div class="form-actions">
      <button type="button" mat-stroked-button (click)="goBack()" [disabled]="isSaving">
        Cancel
      </button>
      <button type="submit" mat-raised-button color="primary"
              [disabled]="accountForm.invalid || isSaving">
        <mat-icon>save</mat-icon>
        {{ isSaving ? 'Saving…' : 'Save Changes' }}
      </button>
    </div>

  </form>

</div>
